import React, { useEffect, useRef } from 'react';

declare global {
  interface Window {
    adsbygoogle: any;
  }
}

interface AdUnitProps {
  format: 'infeed' | 'inarticle' | 'display';
  slot?: string;
  style?: React.CSSProperties;
}

const AD_CONFIG = {
  infeed: {
    slot: '8125085107',
    format: 'fluid',
    layout: '-f9+52+6z-e1+5b',
  },
  inarticle: {
    slot: '3355473147',
    format: 'fluid',
    layout: 'in-article',
  },
  display: {
    slot: '8125085107',
    format: 'auto',
    layout: '',
  },
};

const AdUnit: React.FC<AdUnitProps> = ({ format, slot, style }) => {
  const adRef = useRef<boolean>(false);

  useEffect(() => {
    if (adRef.current) return;
    adRef.current = true;

    const interval = setInterval(() => {
      if (window.adsbygoogle) {
        try {
          window.adsbygoogle.push({});
        } catch (e) {
          console.error(e);
        }
        clearInterval(interval);
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  const config = AD_CONFIG[format];
  const adSlot = slot || config.slot;

  if (format === 'inarticle') {
    return (
      <div className="ad-unit" style={{ minWidth: '250px', margin: '16px 0', ...style }}>
        <ins
          className="adsbygoogle"
          style={{ display: 'block', textAlign: 'center' }}
          data-ad-client="ca-pub-7362317404864344"
          data-ad-layout="in-article"
          data-ad-format="fluid"
          data-ad-slot={adSlot}
          data-full-width-responsive="true"
        />
      </div>
    );
  }

  return (
    <div className="ad-unit" style={{ minWidth: '250px', margin: '16px 0', ...style }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-7362317404864344"
        data-ad-slot={adSlot}
        data-ad-format={config.format}
        {...(config.layout && format === 'infeed' ? { 'data-ad-layout-key': config.layout } : {})}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdUnit;
